/*
  NUDIENT: Leveransen i köpkolumnen, paket D1 del e, M-084 tilläggen och
  svaren om del e 8 och 9 oktober 2026. Plan: nudient/PLAN-D1-kopkolumn.md
  punkt 18.28 och 18.31. Laddas av blocks/nudient-delivery.liquid.

  Alternativen hämtas från Shopifys öppna gränssnitt, Storefront API, utan
  nyckel, som paketens delar i assets/nudient-bundle.js:
  1. cartCreate skapar en egen, tillfällig varukorg med sidans variant och
     adressen, oneTimeUse. Marknaden och språket sätts med @inContext.
  2. deliveryGroups(withCarrierRates: true) ger transportörernas
     alternativ. Shopify kräver @defer, och svaret kommer i delar,
     multipart/mixed.
  3. Den tillfälliga varukorgen töms direkt efteråt, utan att någon väntar
     på svaret.
  Kundens varukorg rörs aldrig, och inga händelser om varukorgen skickas,
  M-084 tillägget punkt 1. Undersökt i planen punkt 18.28.

  - Uppslagningen sker bara när kunden trycker på knappen, eller Enter i
    fältet, aldrig automatiskt när blocket syns eller medan kunden skriver,
    M-084 ändringen av fråga 7 9 oktober 2026. Varje uppslagning räknar
    fram transportörernas priser som kassan, och Shopify spärrar efter för
    många.
  - Medan den laddar visas Icon/Loading/16 vid fältet, som i modellväljaren,
    och knappen är inaktiv, så att samma uppslagning inte görs två gånger.
  - Svaret väntas in i högst 10 sekunder. Sedan visas ett fel, och kunden
    kan trycka på knappen igen.
  - Postnumret och regionen sparas under besöket i sessionStorage och står
    kvar ifyllda. Svaret sparas i 30 minuter per variant, land, region och
    postnummer. Finns ett sparat svar för sidans variant och det sparade
    postnumret visas det direkt, utan ny uppslagning. Annars väntar blocket
    på knappen. Ett tomt svar och ett fel sparas inte. M-084 ändringen av
    fråga 7.
  - Shopify spärrar transportörernas priser tillfälligt efter många
    uppslagningar, och svarar då THROTTLED i den uppskjutna delen. Det
    visas som ett fel, och kunden kan försöka igen. Provat 9 oktober 2026,
    planen punkt 18.31.
  - Namnen börjar med 1 till 6 osynliga tecken, U+200B, som Packrooster
    använder för att ordna alternativen. De tas bort när namnet visas, och
    ordningen behålls.
  - Regionen visas bara för länder i blockets inställning region_countries,
    och bara om Shopify har regioner för landet. Tom inställning ger ingen
    region, som 215:168. Utan region skickas bara postnumret.
  - Ikonen: varje nyckelord ur snippets/nudient-carriers.liquid söks som ett
    helt ord, utan hänsyn till stora och små bokstäver, i namn och
    beskrivning. Första träff vinner. Utan träff ingen ikon, M-084 svaren
    om ikonerna 9 oktober 2026.
  - Högst tre rader, sedan "Visa mer", som visar tre till.

  UNDERHÅLL: API_VERSION byts med den i assets/nudient-bundle.js, ungefär en
  gång om året.

  Värden som inte är tokens:
  - 2026-10: senaste stabila versionen av Storefront API, 7 oktober 2026.
  - 10000 och 30 * 60 * 1000: längsta väntan på svaret och hur länge svaret
    sparas, planen punkt 18.28 och M-084 svaren punkt 7.
  - 3: rader åt gången, M-084 tillägget punkt 3.
  - 10: högst tio leveransgrupper. En vara ger en grupp.
  - 24: ikonens mått, planen punkt 18.28.
  - nudient-delivery:1 och nudient-delivery-address:1: början på nycklarna i
    sessionStorage. Siffran byts när det sparade ändrar form.
  - multipart/mixed; deferSpec=20220824: det Shopify kräver för @defer.
  - \u200b: Packroosters osynliga tecken.
  - 1: en vara i den tillfälliga varukorgen, quantity, och en rad att läsa
    tillbaka för att tömma den, lines(first: 1).
  - gid://shopify/ProductVariant/: Shopifys början på variantens id i
    Storefront API.
  - --graphql: skiljelinjen mellan delarna i Shopifys svar med @defer.
  - \p{L} och \p{N}: bokstäver och siffror, gränsen för ett helt ord.
*/

const API_VERSION = '2026-10';
const TIMEOUT = 10000;
const CACHE_TIME = 30 * 60 * 1000;
const PAGE = 3;
const ADDRESS_KEY = 'nudient-delivery-address:1';

for (const root of document.querySelectorAll('[data-nudient-delivery]')) setup(root);

function setup(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';

  const { variant, country, countryName, language, regionCountries } = root.dataset;
  const regionField = root.querySelector('.nudient-delivery__region');
  const region = regionField.querySelector('select');
  const postalField = root.querySelector('.nudient-delivery__postal');
  const postal = postalField.querySelector('input');
  const list = root.querySelector('[data-list]');
  const message = root.querySelector('[data-message]');
  const more = root.querySelector('[data-more]');
  const form = root.querySelector('[data-form]');
  const check = root.querySelector('[data-check]');
  const rowTemplate = root.querySelector('template[data-row]');
  const loading = root.querySelector('template[data-loading]').content.firstElementChild.cloneNode(true);
  postalField.append(loading);

  let carriers = [];
  try {
    carriers = JSON.parse(root.querySelector('[data-carriers]').textContent).map((carrier) => ({
      ...carrier,
      pattern: new RegExp(`(?<![\\p{L}\\p{N}])${escape(carrier.keyword).replace(/\s+/g, '\\s+')}(?![\\p{L}\\p{N}])`, 'iu'),
    }));
  } catch {}

  /* Regionen är dold, utom för länder i blockets inställning som Shopify
     har regioner för, M-084 svaren på kontrollfrågorna för del e punkt 2 */
  const regionOn = (regionCountries || '').split(',').map((code) => code.trim()).includes(country);
  const hasRegions = regionOn && fillRegions(root, region, countryName);
  root.toggleAttribute('data-regions', hasRegions);

  let controller;
  let options = [];

  /* Det sparade postnumret står kvar. Ett sparat svar visas direkt, utan
     uppslagning. Annars väntar blocket på knappen */
  const saved = readAddress(country);
  if (saved) {
    postal.value = saved.zip;
    if (hasRegions && saved.region) region.value = saved.region;
    const cached = readCache(cacheKey(saved.zip, hasRegions ? region.value : ''));
    if (cached) show(cached);
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    lookup();
  });
  more.addEventListener('click', () => render(list.children.length + PAGE));

  function cacheKey(zip, province) {
    return `nudient-delivery:1:${API_VERSION}:${variant}:${country}:${province}:${zip.toUpperCase()}`;
  }

  async function lookup() {
    if (controller) return;
    const zip = postal.value.trim();
    const province = hasRegions ? region.value : '';
    if (!zip) return;
    saveAddress(country, zip, province);

    const key = cacheKey(zip, province);
    const cached = readCache(key);
    if (cached) {
      show(cached);
      return;
    }

    controller = new AbortController();
    const own = controller;
    const timeout = setTimeout(() => own.abort(), TIMEOUT);
    setBusy(true);
    try {
      const result = await fetchOptions({ variant, country, language, zip, province, signal: own.signal });
      if (result.length) writeCache(key, result);
      show(result);
    } catch {
      showMessage(root.dataset.error);
    } finally {
      clearTimeout(timeout);
      controller = null;
      setBusy(false);
    }
  }

  function setBusy(busy) {
    postalField.toggleAttribute('data-busy', busy);
    root.setAttribute('aria-busy', String(busy));
    check.disabled = busy;
  }

  function clear() {
    options = [];
    list.replaceChildren();
    list.hidden = true;
    message.hidden = true;
    more.hidden = true;
  }

  function show(result) {
    clear();
    setBusy(false);
    options = result;
    if (options.length === 0) {
      showMessage(root.dataset.empty);
      return;
    }
    list.hidden = false;
    render(PAGE);
  }

  function showMessage(text) {
    clear();
    message.textContent = text;
    message.hidden = false;
  }

  function render(count) {
    for (const option of options.slice(list.children.length, count)) {
      const row = rowTemplate.content.firstElementChild.cloneNode(true);
      row.querySelector('[data-name]').textContent = option.name;
      const description = row.querySelector('[data-description]');
      if (option.description) description.textContent = option.description;
      else description.remove();

      const carrier = carriers.find((c) => c.pattern.test(`${option.name} ${option.description}`));
      if (carrier) {
        const img = document.createElement('img');
        img.className = 'nudient-delivery__icon';
        img.src = carrier.src;
        img.alt = '';
        img.width = 24;
        img.height = 24;
        img.loading = 'lazy';
        img.dataset.carrier = carrier.keyword;
        row.append(img);
      }
      list.append(row);
    }
    more.hidden = list.children.length >= options.length;
  }
}

/* Regionerna ur Shopifys all_country_option_tags. Alternativet för sidans
   land hittas på landets namn, som Shopify skriver på sidans språk i både
   localization.country.name och alternativets text. Värdet som skickas är
   regionens namn på engelska, det första i varje par. */
function fillRegions(root, select, countryName) {
  const tags = root.querySelector('template[data-countries]');
  const name = countryName.trim().toLowerCase();
  const option = [...tags.content.querySelectorAll('option')].find(
    (o) => o.textContent.trim().toLowerCase() === name || o.value.trim().toLowerCase() === name
  );
  let provinces = [];
  try {
    provinces = JSON.parse(option?.dataset.provinces || '[]');
  } catch {}
  for (const [value, label] of provinces) select.append(new Option(label || value, value));
  return provinces.length > 0;
}

async function fetchOptions({ variant, country, language, zip, province, signal }) {
  const context = `@inContext(country: ${country}, language: ${language.toUpperCase().replace('-', '_')})`;
  const address = { countryCode: country, zip };
  if (province) address.provinceCode = province;

  const created = await graphql(
    `mutation ($input: CartInput!) ${context} {
      cartCreate(input: $input) { cart { id lines(first: 1) { nodes { id } } } userErrors { message } }
    }`,
    {
      input: {
        lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variant}`, quantity: 1 }],
        delivery: { addresses: [{ address: { deliveryAddress: address }, oneTimeUse: true, selected: true }] },
      },
    },
    signal
  );
  const cart = created.data?.cartCreate?.cart;
  if (!cart) throw new Error('cartCreate');

  try {
    const parts = await graphql(
      `query ($id: ID!) ${context} {
        cart(id: $id) {
          id
          ... @defer {
            deliveryGroups(first: 10, withCarrierRates: true) {
              nodes { deliveryOptions { handle title description } }
            }
          }
        }
      }`,
      { id: cart.id },
      signal,
      true
    );
    /* Ett fel kan stå i den uppskjutna delen, till exempel THROTTLED när
       Shopify tillfälligt spärrar transportörernas priser. Det är ett fel,
       inte ett tomt svar, provat 9 oktober 2026 */
    const incremental = parts.flatMap((part) => part.incremental || []);
    if (parts.some((part) => part.errors) || incremental.some((i) => i.errors || !i.data)) throw new Error('deliveryGroups');
    const groups = [...parts.map((part) => part.data), ...incremental.map((i) => i.data)].filter(Boolean);
    const nodes = groups.flatMap((data) => (data.deliveryGroups || data.cart?.deliveryGroups)?.nodes || []);
    return nodes.flatMap((group) =>
      group.deliveryOptions.map((option) => ({
        name: (option.title || '').replace(/\u200b/g, '').trim(),
        description: (option.description || '').trim(),
      }))
    );
  } finally {
    /* Den tillfälliga varukorgen töms, utan att vänta på svaret */
    const lineIds = cart.lines.nodes.map((line) => line.id);
    if (lineIds.length) {
      graphql(
        `mutation ($id: ID!, $lineIds: [ID!]!) { cartLinesRemove(cartId: $id, lineIds: $lineIds) { cart { id } } }`,
        { id: cart.id, lineIds }
      ).catch(() => {});
    }
  }
}

async function graphql(query, variables, signal, deferred = false) {
  const response = await fetch(`${location.origin}/api/${API_VERSION}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: deferred ? 'multipart/mixed; deferSpec=20220824, application/json' : 'application/json',
    },
    body: JSON.stringify({ query, variables }),
    signal,
  });
  const text = await response.text();
  if (!response.ok) throw new Error('Storefront API');
  if (!deferred) {
    const json = JSON.parse(text);
    if (json.errors) throw new Error('Storefront API');
    return json;
  }
  if (!(response.headers.get('content-type') || '').includes('multipart')) return [JSON.parse(text)];
  return text
    .split(/\r?\n--graphql(?:--)?\r?\n?/)
    .map((chunk) => chunk.slice(chunk.indexOf('{')))
    .filter((chunk) => chunk.startsWith('{'))
    .map((chunk) => JSON.parse(chunk.trim()));
}

function escape(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function readAddress(country) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(ADDRESS_KEY) || 'null');
    if (saved && saved.country === country && saved.zip) return saved;
  } catch {}
  return null;
}

function saveAddress(country, zip, region) {
  try {
    sessionStorage.setItem(ADDRESS_KEY, JSON.stringify({ country, zip, region }));
  } catch {}
}

function readCache(key) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && Date.now() - saved.time < CACHE_TIME) return saved.options;
  } catch {}
  return null;
}

function writeCache(key, options) {
  try {
    sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), options }));
  } catch {}
}
